import { getApolloClient } from '../lib/getApolloClient';
import {
  GET_ASSET_TEMPLATES_FOR_TENANT,
  GET_ASSETS_FOR_USER,
} from './asset.gql';

const fetchAssetsForUser = async (userId: string) => {
  try {
    const { data } = await getApolloClient().query({
      query: GET_ASSETS_FOR_USER,
      variables: { userId },
    });
    if (data.getAssetsForUser) {
      return data.getAssetsForUser;
    }
    return [];
  } catch (error) {
    console.error('Error fetching assets for user: ', error);
    throw error;
  }
};

const fetchAssetTemplatesForTenant = async (tenantId: string) => {
  try {
    const { data } = await getApolloClient().query({
      query: GET_ASSET_TEMPLATES_FOR_TENANT,
      variables: { tenantId },
    });
    if (data.getAssetTemplatesForTenant) {
      return data.getAssetTemplatesForTenant;
    }
    return [];
  } catch (error) {
    console.error('Error fetching asset templates for tenant: ', error);
    throw error;
  }
};

export const assetActions = {
  fetchAssetsForUser,
  fetchAssetTemplatesForTenant,
};
